import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ReopenStreamMutation } from "../graphql/mutations";
import type {
  ReopenStreamMutationType,
  ReopenStreamMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useReopenStreamMutation = (
  options?: MutationHookOptions<
    ReopenStreamMutationType,
    ReopenStreamMutationVariablesType
  >
) => {
  return useMutation<
    ReopenStreamMutationType,
    ReopenStreamMutationVariablesType
  >(ReopenStreamMutation, options);
};
